import { UsersSearchColumn } from '../components/UsersSearchColumn';
import { DevicesSearchColumn } from '../components/DevicesSearchColumn';
import { Users } from 'lucide-react';

export function CustomersPage() {
  return (
    <div className="flex flex-col gap-6 p-6" data-testid="customers-page">
      <div className="flex flex-col gap-1">
        <h1 className="flex items-center gap-2 text-2xl font-bold text-foreground">
          <Users className="h-6 w-6" />
          {'Customers'}
        </h1>
        <p className="text-sm text-muted-foreground">
          {'Search users by email or domain, or devices by name, UUID, device ID, or pairing code.'}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <UsersSearchColumn />
        <DevicesSearchColumn />
      </div>
    </div>
  );
}
